import { render } from "./HeroiconsSolidCurrencyBangladeshi.vue?vue&type=template&id=789e1b8f"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyBangladeshi.vue"]])

export default __exports__